<template>
	<v-app>
		<div v-if="currentUser">
			<app-bar :mini.sync="navbarMini" :drawerExtended.sync="navbarExtended" :permanent="permanent">
				<v-app-bar-title>
					<router-link to="/">
						<v-img alt="logo" contain :src="logoUrl" transition="scale-transition" width="120" />
					</router-link>
				</v-app-bar-title>
				<v-spacer />
				<!-- middle content goes here -->
				<v-spacer />

				<!-- step in rem -->
				<font-size-ticker :stepSize="0.1" :steps="3" upCount />
				<app-bar-user :currentUser="currentUser" />
				<v-divider class="mx-4" inset vertical></v-divider>
				<app-bar-menu :currentUser="currentUser" />
			</app-bar>
			<l-navigation
				v-model="navbarExtended"
				:miniVariant="navbarMini"
				:permanent="permanent"
				:navItems="navigationStructure.filter((item) => !!item.icon)"
				app
				clipped
				left
			></l-navigation>

			<sideboard
				v-if="currentRouteHasView('rightSideboard')"
				:mini.sync="rightSideboardMini"
				permanent
				app
				clipped
				right
			>
				<router-view name="rightSideboard"></router-view>
			</sideboard>
		</div>
		<v-main>
			<router-view />
		</v-main>
		<global-messages />
		<!-- <global-overlay-loader /> -->
		<loading-dialog />
	</v-app>
</template>

<script>
import { mapState } from 'pinia';
import { useAuthStore } from '@/plugins/auth/store';
import { navigationStructure } from '@/router/routes';
import AppBar from '@/components/layout/appBar/AppBar.vue';
import LNavigation from '@/components/layout/navigation/LNavigation.vue';
import GlobalMessages from '@/plugins/clientModels/components/globalMessages/GlobalMessages.vue';
import GlobalOverlayLoader from '@/plugins/clientModels/components/GlobalOverlayLoader.vue';
import LoadingDialog from '@/components/base/loadingDialog/LoadingDialog.vue';
import AppBarMenu from '@/components/layout/appBar/appBarMenu/AppBarMenu.vue';
import AppBarUser from '@/components/layout/appBar/appBarUser/AppBarUser.vue';
import FontSizeTicker from '@/components/base/fontSizeTicker/FontSizeTicker.vue';

export default {
	name: 'App',
	components: {
		AppBar,
		LNavigation,
		GlobalMessages,
		GlobalOverlayLoader,
		LoadingDialog,
		AppBarMenu,
		AppBarUser,
		FontSizeTicker,
	},
	data: () => ({
		navigationStructure,
		navbarExtended: false,
		navbarMini: false,
		rightSideboardMini: false,
	}),
	computed: {
		permanent() {
			return this.$vuetify.breakpoint.mdAndUp;
		},
		sideboardExpandOnHover() {
			return this.$vuetify.breakpoint.mdAndDown;
		},
		...mapState(useAuthStore, { currentUser: 'login' }),
		logoUrl() {
			if (this.$vuetify.theme.dark) {
				return '/logos/logo_dark.svg';
			} else {
				return '/logos/logo_light.svg';
			}
		},
	},
	methods: {
		currentRouteHasView(viewName) {
			const found = this.navigationStructure.filter(
				(route) => route.path === this.$route.path && route.components && route.components[viewName]
			);
			return found.length;
		},
		switchHotkeyRoutes(e) {
			const foundRoutes = this.navigationStructure.filter((item) => item.hotkey === e.key);
			if (foundRoutes.length === 1 && (e.ctrlKey || e.metaKey) && this.$route.path !== foundRoutes[0].path) {
				e.preventDefault();
				this.$router.push(foundRoutes[0].path);
			}
		},
	},
	created() {
		this.navbarExtended = this.$vuetify.breakpoint.mdAndUp;
		this.navbarMini = this.$vuetify.breakpoint.mdAndUp && this.$vuetify.breakpoint.lmdAndDown;
		this.rightSideboardMini = this.$vuetify.breakpoint.mdAndUp && this.$vuetify.breakpoint.mdAndDown;

		window.addEventListener('keydown', this.switchHotkeyRoutes);
	},
	destroyed() {
		window.removeEventListener('keydown', this.switchHotkeyRoutes);
	},
};
</script>
